import gql from 'graphql-tag'

export const getGroupTypeDetailApi = () => gql`
  query getGroupTypeDetail($groupTypeId: String, $tcin: String) {
    getGroupTypeDetail(groupTypeId: $groupTypeId, tcin: $tcin) {
      groupTypePayload {
        content
        pageable
        last
        totalElements
        totalPages
        size
        numberOfElements
      }
      error {
        message
      }
    }
  }
`

export const getComponentTypeApi = gql`
  query GetComponentType {
    getComponentType {
      getComponentTypeLists {
        displayValue
        value
        groupTypeId
        groupType
        allowedUserRoles
        visible
      }
    }
  }
`
